import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import FormDefEditor from "../../components/form/formDefEditor.core";
import Layout from "../../components/layouts/layout.comp";
import formCore from "../../core/form.core";
import { useTranslation } from "../../core/translation.core";
import { FormDefFormData } from "../../types/form";

export default function FormDefEditPage() {
  const { t, msg } = useTranslation();
  const methods = useForm<FormDefFormData>();
  const router = useRouter();

  async function onSubmit(data: FormDefFormData) {
    await formCore.createDef({
      code: data.code,
      subject: data.subject,
      mailTemplate: data.mailTemplate,
      notifyEmails: data.notifyEmails.filter((e) => e !== null && e !== undefined && e !== ""),
    });
    router.push("/form/defList");
  }

  return (
    <Layout title={t(msg.formSubmit.createForm)}>
      <FormDefEditor methods={methods} onSubmit={onSubmit} />
    </Layout>
  );
}
